import { render, staticRenderFns } from "./EmailSheet.vue?vue&type=template&id=40a8fa07"
import script from "./EmailSheet.vue?vue&type=script&lang=js"
export * from "./EmailSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports